export default {
  variant: 'cards.paper',
  borderRadius: '15px',
  p: [null, 4, 5, null, 9],
};
